import { toPersistedState } from 'Helper/statePersistanceWrapper'
import { persistedSliceReplacers } from './persistedSlices'

const LOGOUT_ACTION = 'xtract-auth@reducer-logout'

// Slices that keep their live value across a logout, and why:
//   router  - mirrors the browser history, which is not being reset
//   streams - holds open EventSource handles, which have to be closed, not dropped
//   auth    - its reducer shapes its own logout state, which the login screen reads
//   log     - may hold events that failed to send before logout, retried after login
// Persisted slices (persistedSlices.js) are reduced to their stored form, which is
// what a reload would restore. Every other slice is reset to its startup value, so
// a slice added later is cleared by default.
export const PRESERVED_ON_LOGOUT = ['router', 'streams', 'auth', 'log']

export default (reducer, startupState) => (state, action) => {
  if (state === undefined || action.type !== LOGOUT_ACTION) {
    return reducer(state, action)
  }

  const resetState = {}
  Object.keys(state).forEach(key => {
    if (PRESERVED_ON_LOGOUT.includes(key)) {
      resetState[key] = state[key]
    } else if (key in persistedSliceReplacers) {
      resetState[key] = toPersistedState(state[key], persistedSliceReplacers[key])
    } else {
      resetState[key] = startupState[key]
    }
  })
  return reducer(resetState, action)
}
